import { Button } from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import { CFINotesCardProps } from '../types/CFINotesCardProps';
import '../../../common/action-required-card/components/ActionRequiredCard.scss';

export default function CFINotesCard(props: CFINotesCardProps) {

    const navigate = useNavigate();
    const noteCount = props.statData.find(x => x.statID === props.statID)?.total ?? 0;

    return (
        <div className='ar-button dx-card ar-button-no-pending'>
            <div className='ar-text ar-text-multiline'>Notes</div>
            <div className='ar-total'>
                <span>{noteCount}</span>
            </div>
            <Button onClick={() => navigate(props.url)}>
                Read Notes
            </Button>
        </div>
    )
} 
